try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {
}

// Rarely used libraries are split into separate chunks and fetched on first use.
const loadSwal = () => import(/* webpackChunkName: "sweetalert2" */ 'sweetalert2')
    .then(m => (window.Swal = m.default || m));
const loadPhotoSwipe = () => import(/* webpackChunkName: "photoswipe" */ './files/photoswipe/dist/photoswipe.esm.js');
window.loadSwal = loadSwal;

// Stub jQuery plugins until their chunk arrives: the first call loads the real plugin
// (which overwrites the stub) and replays the call.
function lazyJqueryPlugin(name, loader) {
    let promise = null;
    const stub = $.fn[name] = function (...args) {
        if (!this.length) return this;
        promise = promise || loader().then(() => {
            if ($.fn[name] === stub) throw new Error(name + ' failed to register');
        });
        promise.then(() => this[name](...args));
        return this;
    };
}
lazyJqueryPlugin('select2', () => import(/* webpackChunkName: "select2" */ './lazy/select2'));
lazyJqueryPlugin('owlCarousel', () => import(/* webpackChunkName: "owl.carousel" */ 'owl.carousel'));


// Only the Bootstrap components the storefront uses (data attributes and the jQuery
// .modal()/.tooltip()/.popover() calls); the rest of the bundle was unused weight.
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/modal');
require('bootstrap/js/dist/tab');
require('bootstrap/js/dist/tooltip');
require('bootstrap/js/dist/popover');

require('lazyload')

const loadPhotoSwipeLightbox = () => import(/* webpackChunkName: "photoswipe-lightbox" */ './files/photoswipe/dist/photoswipe-lightbox.esm.js')
    .then(module => (window.PhotoSwipeLightbox = module.default));

// Owl Carousel renders unnamed nav/dot buttons with an invalid role; give them accessible names.
$(document).on('initialized.owl.carousel refreshed.owl.carousel', function (event) {
    const $carousel = $(event.target);
    $carousel.find('.owl-prev').removeAttr('role').attr('aria-label', 'قبلی');
    $carousel.find('.owl-next').removeAttr('role').attr('aria-label', 'بعدی');
    $carousel.find('.owl-dot').each(function (index) {
        $(this).removeAttr('role').attr('aria-label', 'اسلاید ' + (index + 1));
    });
});

window.addEventListener("load", (event) => {
    $('.nav-link-home').addClass('show');
});

// Alpine is only used by a few forms (x-data), so fetch it when such markup is on the page,
// including markup Livewire adds later.
let alpineLoading = false;
function loadAlpineIfNeeded() {
    if (alpineLoading || !document.querySelector('[x-data]')) return;
    alpineLoading = true;
    import(/* webpackChunkName: "alpine" */ 'alpinejs').then(({default: Alpine}) => {
        window.Alpine = Alpine;
        Alpine.start();
    });
}
loadAlpineIfNeeded();
if (window.Livewire) window.Livewire.hook('message.processed', loadAlpineIfNeeded);


$(function () {
    $('.brand_slider .owl-carousel').owlCarousel({
        stagePadding: 50,
        rtl: true,
        loop: true,
        margin: 10,
        nav: false,
        dots: false,
        responsive: {
            0: {
                items: 3.3,
                stagePadding: 5,
            },
            400: {
                items: 3.3
            },
            768: {
                items: 4.4
            },
            1200: {
                items: 5
            }
        }
    });

    document.addEventListener("scroll", (event) => {
        let lastKnownScrollPosition = window.scrollY;
        if (lastKnownScrollPosition >= 100) {
            $('#sectionLogoHeader').addClass('hide-header-logo')
        } else {
            $('#sectionLogoHeader').removeClass('hide-header-logo')
        }
    }, {passive: true});

    window.addEventListener('sweetAlert', function (e) {

        loadSwal().then(Swal => Swal.fire({
            title: e.detail.title,
            icon: e.detail.icon,
            toast: true,
            showConfirmButton: false,
            position: 'top-right',
            timer: 3000
        }));
    });

    window.addEventListener('tooltip', function (e) {
        $('[data-toggle="tooltip"]').tooltip()
    });


    window.addEventListener('closeModal', function (e) {
        $('#' + e.detail).modal('hide');
    })


    window.addEventListener('openModal', function (e) {
        $('#' + e.detail).modal('show');
        $('.card-fixed').addClass('stop-scrolling')
    })

    window.addEventListener('select2', function (e) {
        $('.js-example-basic-multiple').select2();
    });

    $('#featureProductSection .owl-carousel').owlCarousel({
        loop: false,
        rtl: true,
        center: false,
        margin: 0,
        autoWidth: true,
        nav: true,
        dots: false,
        navText: [
            "<i class='fas fa-chevron-right'></i>",
            "<i class='fas fa-chevron-left'></i>"
        ],
        autoplay: false,
    });
    $('#owlCarouselFeatureProduct .owl-carousel').owlCarousel({
        loop: false,
        rtl: true,
        center: false,
        margin: 0,
        autoWidth: true,
        nav: true,
        dots: false,
        navText: [
            "<i class='fas fa-chevron-right'></i>",
            "<i class='fas fa-chevron-left'></i>"
        ],
        autoplay: false,
    })

    window.addEventListener('FeatureProductCarousel', function (e) {
        const owl = $('#owlCarouselFeatureProduct'); // Owl carousel in question
        $(owl).trigger('destroy.owl.carousel'); // Destroy carousel instance
        $(owl).html($(owl).find('.owl-stage-outer').html()).removeClass('owl-loaded'); // Destroy carousel instance part 2
        $(owl).owlCarousel({
            loop: false,
            rtl: true,
            center: false,
            margin: 0,
            autoWidth: true,
            nav: true,
            dots: false,
            navText: [
                "<i class='fas fa-chevron-right'></i>",
                "<i class='fas fa-chevron-left'></i>"
            ],
            autoplay: false,
        }); // Initialize Owl carousel once again with same config options
    });

    // The homepage slider is rendered on the server; initialise it once on load and
    // again whenever Livewire re-renders it.
    function initHomeSlider() {
        const $slider = $('#slider-carousel .owl-carousel');
        if (!$slider.length || $slider.hasClass('owl-loaded') || !$slider.children().length) return;
        $slider.owlCarousel({
            loop: true,
            rtl: true,
            center: true,
            margin: 0,
            nav: true,
            dots: true,
            autoplayTimeout: 3500,
            navText: [
                "<i class='fas fa-chevron-right'></i>",
                "<i class='fas fa-chevron-left'></i>"
            ],
            autoplay: true,
            autoplayHoverPause: true,
            responsive: {
                0: {
                    items: 1
                }
            }
        })
    }

    initHomeSlider();
    window.addEventListener('SliderCarousel', initHomeSlider);
    window.addEventListener('SliderCarouselMobile', initHomeSlider);

});


$(document).ready(function () {
    document.addEventListener('contextmenu', event => event.preventDefault());
    $('#loginModal').on('shown.bs.modal', function () {
        $('#mobile').focus();
    });
    $('#searchModal').on('shown.bs.modal', function () {
        $('#inputSearchHeader').focus();
    });

    // Enable Bootstrap tooltips on page load
    $('[data-bs-toggle="tooltip"]').tooltip();
    $('[data-bs-toggle="popover"]').popover();

    // Ensure Livewire updates re-instantiate tooltips
    if (typeof window.Livewire !== 'undefined') {
        window.Livewire.hook('message.processed', (message, component) => {
            $('[data-bs-toggle="tooltip"]').tooltip('dispose').tooltip();
            $('[data-bs-toggle="popover"]').popover('dispose').popover();
        });
    }


    jQuery('.btn-cart-header').click(function (e) {
        e.preventDefault();

        if ($('.mini-cart').hasClass('show'))
            $('.mini-cart').removeClass('show')
        else
            $('.mini-cart').addClass('show')

    });

    jQuery('.btn-tire-filter').click(function (e) {
        e.preventDefault();
        let target = $(this).attr('data-tab');
        $('.btn-tire-filter').removeClass('active');
        $('.tab-tire-filter').addClass('d-none');
        $(this).addClass('active');
        $(target).removeClass('d-none');
    });
    jQuery('.set-filter-tire-tab').change(function (e) {
        e.preventDefault();
        let target = $(this).attr('data-tab');
        Livewire.emit('set-tire-filter-tab', target)
    });

    let lastMouseDownX = 0;
    let lastMouseDownY = 0;
    let lastMouseDownWasOutside = false;

    const mouseDownListener = (event) => {
        lastMouseDownX = event.offsetX;
        lastMouseDownY = event.offsetY;
        lastMouseDownWasOutside = !$(event.target).closest('.mini-cart').length;

        if (lastMouseDownWasOutside && $('.mini-cart').hasClass('show'))
            $('.mini-cart').removeClass('show');
    }
    document.addEventListener('mousedown', mouseDownListener);


    jQuery(document).on("click", ".btn-tab-feature-product", function (e) {
        e.preventDefault();
        let btnTabs = $('.btn-tab-feature-product');
        let tab = $(this).attr('data-tab');

        if ($(this).hasClass('active'))
            return;

        $('#featureProductSection').addClass('d-none');
        btnTabs.removeClass('active');
        $(this).addClass('active')
        $('#loadingFeatureProduct').removeClass('d-none')
        Livewire.emit('set-tab-feature-product', tab);

    });

    jQuery(document).on("click", ".btn-set-previous-page", function (e) {
        let url = $(this).attr('data-previous')
        if (url)
            Livewire.emit('setPreviousPage', url);
        else
            Livewire.emit('setPreviousPage', null);
    });


    $('#inputSearchHeader').keyup(function (e) {
        clearTimeout(timeoutID);
        const value = e.target.value
        timeoutID = setTimeout(() => findMember(value), 500)
    });

    let timeoutID = null;

    function findMember(str) {

        $('#spinnerLoadingSearch').removeClass('d-none');
        $('#loadingSearch').removeClass('d-none');
        Livewire.emit('set-query-search-modal', str);
    }


    $('#inputSearchSidebar').keyup(function (e) {
        clearTimeout(timeoutID);
        const value = e.target.value
        timeoutID = setTimeout(() => findMemberSideBar(value), 500)
    });


    function findMemberSideBar(str) {

        $('#spinnerLoadingSearchSidebar').removeClass('d-none');
        $('#preloadProductsList').removeClass('d-none');
        Livewire.emit('set-query-search-sidebar', str);
    }

    $('#inputSearchBrand').keyup(function (e) {
        clearTimeout(timeoutID);
        const value = e.target.value
        timeoutID = setTimeout(() => findMemberBrand(value), 500)
    });


    function findMemberBrand(str) {

        $('#preloadBrandList').removeClass('d-none');
        Livewire.emit('set-query-search-brand', str);
    }

    $("#rangeComment").on("input change", function () {
        let value = $("#rangeComment").val();
        document.getElementById('notActiveRangeComment').style.width = (100 - value * 20) + '%';
        document.getElementById('activeRangeComment').style.width = value * 20 + '%';
    });


    jQuery(document).on("click", ".btn-comment-like-product", function (e) {
        e.preventDefault();
        let likeMove = jQuery(this).closest('.btn-comment-like-product');
        let dataId = likeMove.attr('data-id');
        let count = likeMove.attr('data-count');
        Livewire.emit('comment-like-product', dataId, 'like');
        if (jQuery(this).children('i').get(0).classList.contains('far')) {
            jQuery(this).html('<i class="fas fa-thumbs-up ms-1 fa-lg"></i> ' + ++count);
            let dislike = jQuery('#btn-dislike-' + dataId).attr('data-count');

            if (jQuery('#btn-dislike-' + dataId).children('i').get(0).classList.contains('fas')) {
                --dislike;
                console.log(dislike);
                jQuery('#btn-dislike-' + dataId).attr('data-count', dislike);
            }

            jQuery('#btn-dislike-' + dataId).html('<i class="far ms-1 fa-thumbs-down fa-lg"></i> ' + dislike);
            likeMove.attr('data-count', count);
        } else {
            jQuery(this).html('<i class="far fa-thumbs-up ms-1 fa-lg"></i> ' + --count);
            likeMove.attr('data-count', count);
        }
    });

    jQuery(document).on("click", ".btn-comment-dislike-product", function (e) {
        e.preventDefault();
        let dislikeMove = jQuery(this).closest('.btn-comment-dislike-product');
        let dataId = dislikeMove.attr('data-id');
        let count = dislikeMove.attr('data-count');
        Livewire.emit('comment-like-product', dataId, 'dislike');

        if (jQuery(this).children('i').get(0).classList.contains('far')) {
            jQuery(this).html('<i class="fas fa-thumbs-down ms-1 fa-lg"></i> ' + ++count);
            var like = jQuery('#btn-like-' + dataId).attr('data-count');

            if (jQuery('#btn-like-' + dataId).children('i').get(0).classList.contains('fas')) {
                --like;
                console.log(like);
                jQuery('#btn-like-' + dataId).attr('data-count', like);
            }

            jQuery('#btn-like-' + dataId).html('<i class="far fa-thumbs-up ms-1 fa-lg"></i> ' + like);
            dislikeMove.attr('data-count', count);
        } else {
            jQuery(this).html('<i class="far fa-thumbs-down ms-1 fa-lg"></i> ' + --count);
            dislikeMove.attr('data-count', count);
        }
    });

});


$(document).ready(function () {

    if (document.querySelector('#gallerySite, #galleryMobile')) {
        loadPhotoSwipeLightbox().then(PhotoSwipeLightbox => {
            for (const selector of ['#gallerySite', '#galleryMobile']) {
                if (!document.querySelector(selector)) continue;
                new PhotoSwipeLightbox({
                    gallery: selector,
                    children: 'a:not(.product-gallery-excluded)',
                    pswpModule: loadPhotoSwipe
                }).init();
            }
        });
    }

    document.querySelectorAll('.product-gallery').forEach((gallery) => {
        const mainItems = gallery.querySelectorAll('.product-gallery-main-media');
        const thumbnails = gallery.querySelectorAll('.product-gallery-thumbnail');

        const showItem = (index) => {
            mainItems.forEach((item, itemIndex) => {
                item.classList.toggle('d-none', itemIndex !== index);
                if (itemIndex !== index && item.tagName === 'VIDEO') item.pause();
            });
            thumbnails.forEach((item, itemIndex) => {
                item.classList.toggle('active', itemIndex === index);
                item.setAttribute('aria-pressed', itemIndex === index ? 'true' : 'false');
            });
        };

        thumbnails.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => showItem(index));
        });

        // Delegate because Livewire replaces the color controls after selection.
        document.addEventListener('change', (event) => {
            const input = event.target.closest('[data-product-color]');
            if (!input || !input.checked) return;
            const color = input.dataset.productColor;
            const hasImages = Array.from(mainItems).some(item => item.dataset.colorId === color);
            let firstMatch = -1;
            thumbnails.forEach((thumbnail, index) => {
                const matches = thumbnail.dataset.colorId === color;
                const visible = !hasImages || !thumbnail.dataset.colorId || matches;
                thumbnail.classList.toggle('d-none', !visible);
                mainItems[index].classList.toggle('product-gallery-excluded', !visible);
                if (matches && firstMatch === -1) firstMatch = index;
            });
            showItem(firstMatch === -1 ? 0 : firstMatch);
        });

    });
    $('.carousel-products .owl-carousel').owlCarousel({
        loop: true,
        rtl: true,
        center: false,
        items: 5,
        margin: 5,
        autoWidth: true,
        lazyLoad: true,
        nav: true,
        dots: false,
        navText: [
            "<i class='fas fa-chevron-right ps-4'></i>",
            "<i class='fas fa-chevron-left pe-4'></i>"
        ],
        autoplay: false,
    })

        window.addEventListener('carouselProductsCategoryJs', function (e) {
            $('.carousel-products .owl-carousel').owlCarousel({
                loop: true,
                rtl: true,
                center: false,
                items: 5,
                margin: 5,
                autoWidth: true,
                lazyLoad: true,
                nav: true,
                dots: false,
                navText: [
                    "<i class='fas fa-chevron-right ps-4'></i>",
                    "<i class='fas fa-chevron-left pe-4'></i>"
                ],
                autoplay: false,
            })
        });
});

